var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Invitation"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invitation",
    clipPath: "url(#clip-Invitation)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#f9f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M0-20.2l6.348-4.111,6.32,4.111V-12.4H0Z",
    transform: "translate(5.251 30.388)",
    fill: "none",
    stroke: "#0058a6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M588.5,272.724l6.126,3.823,6.285-4.008",
    transform: "translate(-583.032 -262.346)",
    fill: "none",
    stroke: "#0058a6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M1007.427,6667.193v-7.639h7.729v7.639l-3.689,2.414Z",
    transform: "translate(-999.739 -6655.395)",
    fill: "#fff",
    stroke: "#0c58a3",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3321",
    "data-name": "Group 3321",
    transform: "translate(8.685 5.251)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 2.881,
    cy: 2.881,
    r: 2.881,
    transform: "translate(0 0)",
    fill: "#3ea640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M2010.125-107.61l1.158,1.226,1.62-2.2",
    transform: "translate(-2008.628 110.36)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitation);
export default __webpack_public_path__ + "static/media/Invitation.66aa2d32174269aeb1a3820da0e9e7c8.svg";
export { ForwardRef as ReactComponent };